<template>
  <div class="page-sign-up" :class="(isPrint ? 'is-print' : undefined)" v-scroll-spy="scrollPos">

    <top-subpage-section v-if="!isPrint">
      <page-header title="Signup">
      </page-header>
    </top-subpage-section>

    <div class="page-content-bg" style="position:relative;">

      <div-container class="form-print-logo" v-if="isPrint" :full="'true'" :column-num="'is-11'" padding-bottom="0">
        <div-columns :full="'true'" background-color="gray" :text-align="'center'">
          <img src="../assets/logo-main.svg" />
        </div-columns>
      </div-container>

      <page-subtab :full="(isPrint ? 'true' : undefined)" :column-num="(isPrint ? 'is-11' : undefined)"
        :is-print="isPrint"
        :title-infos="applications"
        :selected-index="applicationIndex"
        @title-changed="onApplicationChanged"></page-subtab>

      <!-- <div-container padding-top="0" padding-bottom="0" style="position:absolute;right:0;top:0;">
        <div-columns padding="0">
          <div style="width:50%;background-color:blue;">
            <h1 style="margin-bottom:0;">hello</h1>
          </div>
        </div-columns>
      </div-container> -->

      <div-container :full="(isPrint ? 'true' : undefined)" :column-num="(isPrint ? 'is-11' : undefined)" padding-bottom="4rem">
        <div-columns :full="(isPrint ? 'true' : undefined)" padding-top="0rem" background-color="white">
          <div class="columns is-gapless">
            <div v-if="!applications[0].isfull" class="column is-12 sign-up-team-section-wrapper"
              :style="[signUpTeamSectionWrapper]">
              <sign-up-team-section :is-print="isPrint"></sign-up-team-section>
            </div>
            <div v-if="!applications[1].isfull" class="column is-12 sign-up-judge-section-wrapper"
              :style="[signUpJudgeSectionWrapper]">
              <sign-up-judge-section :is-print="isPrint"></sign-up-judge-section>
            </div>
          </div>
        </div-columns>
      </div-container>
    </div>

    <vm-back-top :bottom="45" :right="25" :duration="1000" :timing="'ease'" v-if="false">
      <div class="top"><span></span></div>
    </vm-back-top>
  </div>
</template>

<script>
// import _ from 'lodash'
import EventBus from '@/controllers/EventBus'
import Site from '@/apis/Site'
import DivContainer from '@/components/DivContainer'
import DivColumns from '@/components/DivColumns'
import PageHeader from '@/components/PageHeader'
import TopSubpageSection from '@/components/TopSubpageSection'
import PageSubtab from '@/components/PageSubtab'
import SignUpTeamSection from './SignUpTeamSection'
import SignUpJudgeSection from './SignUpJudgeSection'

export default {
  name: 'about',
  components: {
    DivContainer,
    DivColumns,
    PageHeader,
    TopSubpageSection,
    PageSubtab,
    SignUpTeamSection,
    SignUpJudgeSection
  },
  data () {
    return {
      applications: [{
        id: 'sign-up-team',
        title: 'Team Application',
        strikethrough: true,
        disabled: true,
        disabledText: 'Team Application Is Not Open Yet',
        isfull: true
      }, {
        id: 'sign-up-judge',
        title: 'Judge Application',
        strikethrough: true,
        disabled: true,
        disabledText: 'All Judging Spots Full',
        isfull: true
      }],
      defaultDisabledTextTeam: 'Team Application Is Not Open Yet',
      defaultDisabledTextJudge: 'All Judging Spots Full',
      applicationCurrent: 'sign-up-team',
      applicationIndex: 0,
      signUpTeamSectionWrapper: {
        display: 'block'
      },
      signUpJudgeSectionWrapper: {
        display: 'none'
      },
      isDesktop: true,
      isPrint: false,
      // itemsEnded: false,
      scrollPos: 0
    }
  },
  computed: {
    isDebug: function () {
      return (this.$route.query.hasOwnProperty('debug') && this.$route.query.debug === '1')
    }
  },
  watch: {
  },
  created () {
    // let isSignUp = false
    // let isDebug = this.isDebug
    // console.log('-- is sign up', isSignUp)
    // console.log('-- is debug', isDebug)
    // let isfull = !isSignUp
    console.log('-- sign up created')
  },
  async mounted () {
    if (this.$route.query && this.$route.query.anchor) {
      console.log('scroll to: ' + this.$route.query.anchor)
      setTimeout(function () {
        this.$scrollTo('#' + this.$route.query.anchor)
      }.bind(this), 2000)
    }

    if (this.$route.query) {
      if (this.$route.query.type) {
        var type = this.$route.query.type
        switch (type) {
          case 'judge':
            // this.applicationCurrent = 'sign-up-team'
            // this.applicationIndex = 0
            // this.onApplicationChanged(this.applicationCurrent)
            // this.$nextTick(() => {
            //   let query = _.assign({}, this.$route.query)
            //   query.type = 'team'
            //   this.$router.replace({ name: this.$route.name, query: query })
            // })
            // break
            this.applicationCurrent = 'sign-up-judge'
            this.applicationIndex = 1
            this.onApplicationChanged(this.applicationCurrent)
            break
          case 'team':
          default:
            this.applicationCurrent = 'sign-up-team'
            this.applicationIndex = 0
            this.onApplicationChanged(this.applicationCurrent)
            break
        }
      }

      if (this.$route.query.print && this.$route.query.print === 'true') {
        this.isPrint = true
      } else {
        this.isPrint = false
      }
    } else {
      // reset
      this.applicationCurrent = 'sign-up-team'
      this.applicationIndex = 0
      this.isPrint = false
    }

    // init
    let disabled = true
    this.$set(this.applications[0], 'strikethrough', disabled)
    this.$set(this.applications[0], 'isfull', disabled)
    this.$set(this.applications[0], 'disabledText', this.defaultDisabledTextTeam)
    this.$set(this.applications[1], 'strikethrough', disabled)
    this.$set(this.applications[1], 'isfull', disabled)
    this.$set(this.applications[1], 'disabledText', this.defaultDisabledTextJudge)

    try {
      let data = await Site.aboutWithName('bosshog::signup-team')
      if (data && data.hasOwnProperty('disabled')) {
        this.$set(this.applications[0], 'strikethrough', data.disabled)
        this.$set(this.applications[0], 'isfull', data.disabled)
        this.$set(this.applications[0], 'disabledText', data.content || this.defaultDisabledTextTeam)
      }
    } catch (error) {
      console.error(error)
    }

    try {
      let data = await Site.aboutWithName('bosshog::signup-judge')
      if (data && data.hasOwnProperty('disabled')) {
        this.$set(this.applications[1], 'strikethrough', data.disabled)
        this.$set(this.applications[1], 'isfull', data.disabled)
        this.$set(this.applications[1], 'disabledText', data.content || this.defaultDisabledTextJudge)
      }
    } catch (error) {
      console.error(error)
    }

    if (!this.applications[0].isfull) {
      try {
        let data = await Site.signUpApproved()
        // console.log(data)
        let totalSites = 42
        let remain = totalSites - data.length
        remain = (remain < 0) ? 0 : remain
        this.applications[0].disabledText = 'Only&nbsp;&nbsp;<span style="font-size:1.6em;">' + remain + '</span>&nbsp;&nbsp;Locations Left!'
      } catch (error) {
        console.error(error)
      }
    }

    // on event resize
    this.isDesktop = EventBus._isDesktop
    EventBus.$on('isDesktopChanged', function () {
      this.isDesktop = EventBus._isDesktop
    }.bind(this))
  },
  methods: {
    onScrollTo (name, target) {
      if (this.$route.name !== name) {
        this.$router.replace({ name: name, query: { anchor: target } })
      } else {
        this.$scrollTo('#' + target, { offset: -30 })
      }
    },

    onApplicationChanged: function (applicationType) {
      console.log('application type changed: ' + applicationType)
      this.applicationCurrent = applicationType
      if (applicationType === 'sign-up-team') {
        this.signUpTeamSectionWrapper.display = 'block'
        this.signUpJudgeSectionWrapper.display = 'none'
      } else if (applicationType === 'sign-up-judge') {
        this.signUpTeamSectionWrapper.display = 'none'
        this.signUpJudgeSectionWrapper.display = 'block'
      }
    }
  }
}
</script>

<style lang="scss">
@import "../styles/app_setting.scss";

.page-sign-up {
  position: relative;
  background-color: $color-beige;

  &.is-print {
    background-color: $color-gray-light;
  }

  .page-content-bg {
    padding-top: 4em;
    // background-image: url(../assets/menubg.jpg);
    // background-repeat: no-repeat;
    // background-position: top;

    .form-print-logo {
      print-color-adjust: exact;
      -webkit-print-color-adjust: exact;
    }
  }
}

</style>



// WEBPACK FOOTER //
// SignUp.vue?b8fb0cb0